import { render, staticRenderFns } from "./SinoticoComponent.vue?vue&type=template&id=6666800a&scoped=true&"
import script from "./SinoticoComponent.vue?vue&type=script&lang=js&"
export * from "./SinoticoComponent.vue?vue&type=script&lang=js&"
import style0 from "./SinoticoComponent.vue?vue&type=style&index=0&id=6666800a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666800a",
  null
  
)

export default component.exports